import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  modules: {
    newOrderdata: {
      namespaced: true,
      state: {
        product: [],
        segment: [],
        karat: [],
        distributor: [],
        ordertype: [],
        attribute_name_data: [],
        uomdata: [],
      },
      mutations: {
        product(state, data) {
          state.product = data
        },
        segment(state, data) {
          state.segment = data
        },
        karat(state, data) {
          state.karat = data
        },
        distributor(state, data) {
          state.distributor = data
        },
        ordertype(state, data) {
          state.ordertype = data
        },
        attribute_name_data(state, data) {
          state.attribute_name_data = data
        },
        uomdata(state, data) {
          state.uomdata = data
        }
      }
    }
  },
  plugins: [
    createPersistedState({
      key: 'my-vue-app',
      storage: window.localStorage
    })
  ]
})
